<template>
  <div class="dic-data">
    <el-container>
      <el-header>
        <div style="display:flex;justify-content :flex-end">
          <el-button
            style=" background-color: #000;color: #fff;"
            @click="saveSortData(apiObjDrag)"
          >排序保存提交</el-button>
          <el-button
            style=" background-color: #000;color: #fff;margin-left:20px"
            @click="addActivityBrandList()"
          >新增推荐店铺</el-button>
        </div>
      </el-header>
      <el-main class="nopadding">
        <el-table stripe ref="table" :data="apiObj" row-key="id">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="店铺logo">
            <template width="100" slot-scope="scope">
              <img style="width:60px;height:60px;border:none;" :src="scope.row.logo" />
            </template>
          </el-table-column>
          <el-table-column label="店铺名称" prop="name" align="left"></el-table-column>
          <el-table-column label="店铺Id" prop="brandId" align="left"></el-table-column>
          <el-table-column label="操作" min-width="100%">
            <template slot-scope="scope">
              <el-popconfirm
                icon="el-icon-delete"
                icon-color="red"
                title="确定删除吗？"
                @confirm="handleDelete(scope.row)"
              >
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
    <!-- 新增 -->
    <div>
      <el-dialog title="新增推荐店铺" :visible.sync="dialogFormVisible" width="20%">
        <el-form :model="form" ref="form">
          <el-form-item label="店铺" prop="brandList">
            <el-select v-model="form.brandList" placeholder="请选择店铺">
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCancle()">取 消</el-button>
          <el-button type="primary" @click="handleSave()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import { addActivityBrand, queryListIdx, ActivityBrandIdx, queryBrandList, deleteActivity } from '../../api'

export default {
  name: 'data',
  data () {
    return {
      formLabelWidth: '220px',
      dialogFormVisible: false,
      brandList: [],
      form: {
        brandList: []
      },
      list: [],
      // 后台给我的数据列表
      apiObj: [],
      // 我给后台的数据
      apiObjDrag: [],
    }
  },
  mounted () {
    this.getDictDatalist()
    this.queryBrandList()
    this.$nextTick(() => {
      this.rowDrop()
    })
  },
  methods: {
    handleDelete (row) {
      console.log(row);
      let para = new URLSearchParams();
      para.append("id", row.id);
      deleteActivity(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          // 更新列表
          this.getDictDatalist()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })

    },
    handleSave () {
      let para = new URLSearchParams();
      if (this.form.brandList) {
        para.append("brandId", this.form.brandList);
        addActivityBrand(para).then(data => {
          if (data.code === 10000) {
            this.dialogFormVisible = false
            this.$nextTick(() => {
              this.$refs['form'].resetFields()
            })
            this.$message({
              message: data.msg,
              type: 'success'
            })
            // 更新列表
            this.getDictDatalist()
          } else {
            this.$message({
              message: '请选择店铺',
              type: 'error'
            })
          }
        })
      } else {
        this.$message({
          message: '请选择店铺',
          type: 'error'
        })
      }


    },
    handleCancle () {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
    },
    addActivityBrandList () {
      this.dialogFormVisible = true
    },
    getDictDatalist () {
      // 获取品牌推荐列表
      queryListIdx().then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.apiObj = data.data
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      }
      )
    },
    //行-拖拽
    rowDrop () {
      // const tbody = document.querySelector() 这样写切换路由找不掉body，解决办法是下面的写法 
      const tbody =  this.$refs.table.$el.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.apiObj.splice(oldIndex, 1)[0]
          _this.apiObj.splice(newIndex, 0, currRow)
          //   拖动后获取newIdex
          let arr = Array.from(_this.apiObj)
          console.log(arr);
          _this.apiObjDrag = arr.map((item, index) => {
            return {
              id: item.id,
              name: item.name,
              brandId: item.brandId,
              bigPic: item.bigPic,
              showStatus: index,
              logo: item.logo,
            }
          })
        },
      })
    },
    // 排序后，把拖动后的结果穿啊给后端
    saveSortData (apiObjDrag) {
      console.log(apiObjDrag);
      if (apiObjDrag == '') {
        this.$message.warning("请先拖动排序之后，再点击");
        return
      } else {
        // 提交给后台
        ActivityBrandIdx(JSON.stringify(apiObjDrag)).then(data => {
          console.log(data);
          if (data = 10000) {
            this.$message({
              message: '排序成功',
              type: 'success'
            })
            this.getDictDatalist()
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }

        })
      }
    },
    // 查询店铺列表
    queryBrandList () {
      let para = new URLSearchParams()
      para.append('pageIndex', 1)
      para.append('pageSize', 1000)
      //请求接口
      queryBrandList(para).then(data => {
        // console.log('品牌', data);
        if (data.code === 10000) {
          this.brandList = data.data.rows
          console.log('正常的赋值', this.brandList);
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
  },
}
</script>
